import { render, staticRenderFns } from "./JustificativaReprovacao.vue?vue&type=template&id=8d291e3a"
import script from "./JustificativaReprovacao.vue?vue&type=script&lang=js"
export * from "./JustificativaReprovacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports